import Home from './Home.data-manager.vue'

export default {
  Home
}